// Claim key constants for customAccessToken claim extraction

export const CLAIM_KEYS = {
  // Authorization claims
  ROLES: 'roles',
  PERMISSIONS: 'permissions',

  // User profile claims
  SUBJECT: 'userId',
  USER_NAME: 'userName',
  USER_EMAIL: 'userEmail',
  ROLE_ID: 'roleId',
  PRIMARY_CLIENT_ID: 'primayClientId',
  VENDOR_ID: 'vendorId',

  // Tenant and application claims
  TENANT: 'tid',
  CLIENT_ID: 'clientId',
  SCOPE: 'scp',
} as const;
